export default "__VITE_ASSET__DzPABqUW__"